/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateOrganizationUserEmailSettingResponseDataFromJSON, UpdateOrganizationUserEmailSettingResponseDataToJSON } from './UpdateOrganizationUserEmailSettingResponseData';
export function UpdateOrganizationUserEmailSettingResponseFromJSON(json) {
    return UpdateOrganizationUserEmailSettingResponseFromJSONTyped(json, false);
}
export function UpdateOrganizationUserEmailSettingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : UpdateOrganizationUserEmailSettingResponseDataFromJSON(json['data'])
    };
}
export function UpdateOrganizationUserEmailSettingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateOrganizationUserEmailSettingResponseDataToJSON(value.data)
    };
}
